import { connect } from "react-redux";
import { quiz1MetaWatch } from "../../actions/quiz1Actions";
import WatchMeta from "../quiz/WatchMeta";

const mapStateToProps = state => ({
  quizN: state.quiz1
});

export default connect(
  mapStateToProps,
  { quizNMetaWatch: quiz1MetaWatch }
)(WatchMeta);
